var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-layout d-flex align-items-center justify-content-center m-0 default-body",class:_vm.isEbipac ? 'theme-ebipac' : 'theme-hka'},[_c('child'),_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }